import React, { useEffect, useState } from "react";
import { rbac } from "../index";
import t from "../../../helpers/t";
import NewLocationButton from "./NewLocationButton";
import { moment, $, Dropdown, DropdownButton } from "../../../../../vendor";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEyeSlash } from "@fortawesome/free-regular-svg-icons";
import { locationActions, useSelector } from "inbooma-api";
import { in_array } from "../../../../utils/Helper";
import { Biscuit } from "../../../../utils";

const LocationsSidebar = (props) => {
  const { dispatch, locations, locationSelectHandle, showResources } = props;
  const locationClassNamePrefix = "inb-location-";
  const _location = useSelector((state) => state.locations_data.patchLocation);
  const _foundResources = useSelector((state) => state.locations_data.get_found_resources);
  const [results, setResults] = useState([]);
  const [locationPending, setLocationPending] = useState(null);
  const [foundResourcesPending, setFoundResourcesPending] = useState(null);
  const [foundResources, setFoundResources] = useState([]);
  const [initialized, setInitialized] = useState(false);
  const [dropdown, setDropdown] = useState({});
  const [setIds, setSetIds] = useState([]);
  let foundArr = {};

  useEffect(() => {
    if (_location.success === "" || !locationPending) {
      return;
    }
    console.log("locationPending", locationPending);
    if (_location.success === true) {
      let clone = [...results];
      console.log(clone);
      for (let i = 0; i < clone.length; i++) {
        console.log(clone[i]);
        if (clone[i].id === locationPending) {
          clone[i].fe_visible = true;
        }
      }
      setResults(clone);
    }
    setLocationPending(null);
  }, [_location]);

  useEffect(() => {
    if (_foundResources.success === "" || foundResourcesPending === null) {
      return;
    }
    if (_foundResources.success === true) {
      setFoundResources(_foundResources.data);
    } else {
      let clone = { ...foundResources };
      clone[foundResourcesPending] = [];
    }
    setFoundResourcesPending(null);
    setInitialized(true);
  }, [_foundResources]);

  const onToggleLeftBar = (ev) => {
    console.log("toggle left sidebar in locations");
    $("#inb-c-sidebar").toggleClass("open");
    $("html,body").scrollTop(0);

    let mapContainer = document.getElementById("inb-c-locations-map-container");

    if (mapContainer.classList.contains("full"))
      mapContainer.classList.replace("full", "none-full");
    else if (mapContainer.classList.contains("none-full"))
      mapContainer.classList.replace("none-full", "full");
  };

  const onLocationClicked = (ev, index) => {
    if (locationPending !== null) {
      return;
    }
    if (typeof locationSelectHandle === "function") {
      locationSelectHandle(results[index].listIndex);
    }
  };

  const onToggleDropdown = (nextShow, meta) => {
    if (nextShow) {
      $(".sticky-top-sortbar").addClass("hide");
    } else {
      $(".sticky-top-sortbar").removeClass("hide");
    }
  };
  const locationSearchHandler = (ev) => {
    if (ev.target.value.length === 0) {
      updateResultList();
      return;
    }

    // query local collection of locations
    let list = [];
    const query = ev.target.value.toLowerCase();
    for (let i = 0; i < locations.length; i++) {
      if (locations[i].name.toLowerCase().indexOf(query) >= 0) {
        list.push(locations[i]);
        list[list.length - 1].listIndex = i;
      }
    }
    setResults(list);
  };

  const updateResultList = () => {
    const el = document.getElementById("_locationsList__search");

    if (typeof el !== "undefined" && el !== null && el?.value?.length === 0) {
      if (
        typeof locations !== "undefined" &&
        locations !== null &&
        results.length !== locations.length
      ) {
        let el = [...locations];
        for (let i = 0; i < locations.length; i++) {
          el[i].listIndex = i;
        }
        setResults(el);
      }
    }
  };

  const updateFeVisible = (e, target) => {
    dispatch(
      locationActions.patchLocation({
        location_id: target.id,
        token: Biscuit.get("token"),
        data: {
          fe_visible: true,
        },
      }),
    );
    setLocationPending(target.id);
  };

  const initialize = () => {
    if (initialized || locationPending !== null || foundResourcesPending !== null) {
      return;
    }
    updateResultList();
    if (results.length > 0 && typeof results.map === "function") {
      dispatch(locationActions.getFoundResourcesResetData());
      dispatch(
        locationActions.getFoudResources({
          id: "",
          token: Biscuit.get("token"),
        }),
      );
      setFoundResourcesPending(true);
    }
  };

  initialize();
  return (
    <aside
      id="inb-c-sidebar"
      className="locations-sidebar"
      style={{ float: "left", zIndex: "9", width: "340px" }}
    >
      <header className="inb-c-left-bar__title">
        <h1 className="inb-page-title" style={{ fontSize: "1.55rem" }}>
          {t("locations", null, "capital")} ({results.length})
        </h1>
      </header>

      {locations.length === 0 && (
        <div>
          <div className="inb-c-loader">
            <div className="inb-c-loader--item inb-c-loader--sidebar-top">
              <div className="inb-c-loader--bg row"></div>
            </div>
          </div>

          <div className="inb-c-loader">
            <div className="inb-c-loader--item inb-c-loader--sidebar-center">
              <div className="inb-c-loader--bg row">
                <div className="loader-mask r-1 medium-offset-8 medium-4 column"></div>
                <div className="loader-mask vert-ph-1"></div>
                <div className="loader-mask vert-ph-2"></div>
                <div className="loader-mask r-2 medium-offset-9 medium-3 column"></div>
                <div className="loader-mask vert-ph-3"></div>
                <div className="loader-mask vert-ph-4"></div>
              </div>
            </div>
          </div>

          <div className="inb-c-loader">
            <div className="inb-c-loader--item inb-c-loader--sidebar-center">
              <div className="inb-c-loader--bg row">
                <div className="loader-mask r-1 medium-offset-8 medium-4 column"></div>
                <div className="loader-mask vert-ph-1"></div>
                <div className="loader-mask vert-ph-2"></div>
                <div className="loader-mask r-2 medium-offset-9 medium-3 column"></div>
                <div className="loader-mask vert-ph-3"></div>
                <div className="loader-mask vert-ph-4"></div>
              </div>
            </div>
          </div>
        </div>
      )}

      <ul className="inb-vert-list" style={{ overflowY: "scroll", maxHeight: "calc(80vh - 75px)" }}>
        <span className="inb-list-title">Liste der Standorte</span>
        <input
          type="text"
          id="_locationsList__search"
          placeholder="Standorte durchsuchen..."
          maxLength="255"
          onChange={(e) => locationSearchHandler(e)}
        />
        {typeof results.map === "function" && (
          <div id="locationsList__content" style={{ lineHeight: "2rem" }}>
            {results.map((location, index) => {
              return (
                <>
                  <li className="locationsListItem">
                    <span className={locationClassNamePrefix + location.id}>
                      {location.fe_visible !== true && (
                        <>
                          <span
                            style={{ paddingRight: ".4em", marginLeft: "-21px" }}
                            title={t("switch visibility")}
                          >
                            <a
                              href="#"
                              onClick={(e) => updateFeVisible(e, location)}
                              style={{ color: "#5d687e" }}
                            >
                              {locationPending === location.id ? (
                                <img
                                  alt="RollingLoader"
                                  className="rollingLoader colorize-black"
                                  src={"assets/img/rolling_loader.svg"}
                                />
                              ) : (
                                <FontAwesomeIcon icon={faEyeSlash} />
                              )}
                            </a>
                          </span>
                        </>
                      )}
                      <a
                        href={"#"}
                        onClick={(e) => {
                          onLocationClicked(e, index);
                        }}
                        style={{ color: "#5d687e" }}
                      >
                        {location.name}
                      </a>
                    </span>
                    <span style={{ float: "right", paddingRight: "10px" }}>
                      {typeof foundResources[location.id] !== "undefined" &&
                        foundResources[location.id].length > 0 && (
                          <>
                            <aside className="inb-c-item__actions" id="asideWidthChange">
                              <DropdownButton
                                id="dropdown-basic-button"
                                title="..."
                                variant="secondary"
                                drop="up-centered"
                                menuAlign="left"
                                align="end"
                                bsPrefix="button round inb-toggle-contingent-dd hover"
                                onToggle={onToggleDropdown}
                              >
                                <ul className="inb-dropdown__list">
                                  <li>
                                    <Dropdown.Item
                                      href="#"
                                      onClick={() =>
                                        showResources(foundResources[location.id], location.name)
                                      }
                                    >
                                      <i className="ico-inb inb-fi-map fi fi-page-edit"></i>
                                      {t("show found resources", null, "capital")}
                                    </Dropdown.Item>
                                  </li>
                                </ul>
                              </DropdownButton>
                            </aside>
                          </>
                        )}
                      {foundResourcesPending === location.id && (
                        <img
                          alt="RollingLoader"
                          className="rollingLoader colorize-black"
                          src={"dist/img/rolling_loader.svg"}
                        />
                      )}
                    </span>
                  </li>
                </>
              );
            })}
          </div>
        )}
      </ul>

      <hr />

      <footer
        style={{ minWidth: "17.7%", bottom: "0px" }}
        className="inb-c-left-bar__footer small-only-float-container center-on-content"
      >
        <a
          href="#"
          id="toggle-left-bar"
          className="button secondary show-for-small-only"
          onClick={(e) => onToggleLeftBar(e)}
        >
          <i className="fi fi-list"></i>
          <span className="show-for-sr">t('open_filter_menu')</span>
        </a>
        {rbac.hasPermission("write") && <NewLocationButton />}
      </footer>
    </aside>
  );
};

export default LocationsSidebar;
